import { render } from "./PopupClose.vue?vue&type=template&id=716256a7"
import script from "./PopupClose.vue?vue&type=script&lang=js"
export * from "./PopupClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__